/********************************************************************
 * Autocomplete by kraaden/autocomplete for ke_search
 *
 * https://github.com/kraaden/autocomplete
 */

import autocomplete from 'autocompleter';

// Search input inside lightbox
let inputLightbox = document.getElementById('ke_search_searchfield_sword');
if (inputLightbox != null) {
    autocomplete({
        input: inputLightbox,
        debounceWaitMs: 500,
        fetch: fetch,
        onSelect: function(item) {
            jQuery( "#ke_search_searchfield_sword" ).val( item.value );
            jQuery( "form#form_kesearch_searchfield" ).submit();
        }
    });
}


// Search input on search page
let inputSearchpage = document.getElementById("ke_search_sword");
if (inputSearchpage != null) {
    autocomplete({
        input: inputSearchpage,
        debounceWaitMs: 500,
        fetch: fetch,
        onSelect: function(item) {
            jQuery( "#ke_search_sword" ).val( item.value );
            jQuery( "form#form_kesearch_pi1" ).submit();
        }
    });
}

function fetch(text, update) {
    jQuery.ajax({
        url: "/?eID=keSearchAutocomplete",
        dataType: "json",
        cache: false,
        data: {
            needle: text,
            amount: 10
        },
        success: function (data) {
            if (data) {
                update(data);
            }
        }
    });
}